import { CloudinaryOptions } from "@swiggy-private/js-utils/dist/cloudinary/types";
import { getCloudinaryUrl as SjSgetCloudinaryUrl } from "@swiggy-private/js-utils";

import { TEAM_LINE } from "@swiggy-private/js-utils";

const LARGEST_LOW_Q_IMAGE_WIDTH = 80;

export const getCloudinaryUrl = (filename = "", options: CloudinaryOptions = {}): string =>
    SjSgetCloudinaryUrl(filename, options, {
        teamLine: TEAM_LINE.PORTAL,
    }) || "";

export const getLowQImageCloudinaryUrl = (filename: string, options: CloudinaryOptions = {}): string => {
    const width =
        options.width && options.width > 0 && options.width < LARGEST_LOW_Q_IMAGE_WIDTH
            ? options.width
            : LARGEST_LOW_Q_IMAGE_WIDTH;
    return `https://media-assets.swiggy.com/swiggy/image/upload/e_blur:800/c_thumb,q_auto:low,w_${width}/${filename}`;
};
